import React from 'react'
import PropTypes from 'prop-types'
import useMediaQuery from 'hec/hooks/useMediaQuery'
import {ExpandContent} from 'hec/components/expand-content'
import {cn} from '@/lib/utils'
import {defaultExpandableChildren} from './utils'

export const ExpandableContent = ({expandOnMobileOnly, expandWithModal, children, attributes}) => {
    const {className, ...restAttributes} = attributes
    const isMobile = useMediaQuery('sm')
    const expandEnabled = expandOnMobileOnly ? isMobile : true

    return expandEnabled ? (
        <div className={cn('flex flex-col', className)} {...restAttributes}>
            <ExpandContent
                content={children}
                withModal={expandWithModal}
                data-testid="expandableContent-ExpandContent"
            />
        </div>
    ) : (
        <div {...attributes}>{children}</div>
    )
}

ExpandableContent.propTypes = {
    expandWithModal: PropTypes.bool,
    expandOnMobileOnly: PropTypes.bool,
    children: PropTypes.node.isRequired,
    attributes: PropTypes.shape({
        className: PropTypes.string
    })
}

export const ExpandableContentDefinition = {
    component: ExpandableContent,
    name: 'ExpandableContent',
    noWrap: true,
    canHaveChildren: true,
    defaultStyles: {
        width: 'auto',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '20px',
        marginBottom: '20px'
    },
    defaultChildren: [defaultExpandableChildren],
    inputs: [
        {
            name: 'expandWithModal',
            type: 'boolean',
            defaultValue: false
        },
        {
            name: 'expandOnMobileOnly',
            type: 'boolean',
            defaultValue: false
        }
    ]
}
